export default __webpack_public_path__ + "static/media/cover-mobile.10e45cde.jpg";